import RectangleButton from './RectangleButton';

export default RectangleButton;
